import { createContext, PropsWithChildren, useContext } from 'react';
import { ROLES } from '../../../../../../const';
import { useConcurso } from '../../../../../../providers/ConcursoProvider';
import { useCheckRoles } from '../../../../../hooks';
import { PuestoProps } from './PuestoRow';

export type PuestoTableProps = {
  idLlamadoConcurso: number;
  withBases?: boolean;
  withGrilla?: boolean;
  withActions?: boolean;
  showBotonesActions?: boolean;
  onShowAvanzarConcurso?: () => void;
  onInscribirme?: (puesto: PuestoProps) => void;
};

const PuestoTableContext = createContext<PuestoTableProps>({
  idLlamadoConcurso: 0,
  withGrilla: false,
  withBases: false,
});

type ProviderProps = PropsWithChildren<PuestoTableProps>;

export const PuestosTableProvider = (props: ProviderProps) => {
  const { children, ...etc } = props;

  const { etapaLlamadoConcurso, esCoordinadorConcursal } = useConcurso();

  // 👇 Estas llamadas van siempre, sin condicional
  const isNotUser = useCheckRoles([ROLES.COMITE, ROLES.DIRECTOR, ROLES.LEGALES]);
  const isComite = useCheckRoles([ROLES.COMITE]);
  const isUser = useCheckRoles([ROLES.USER]);

  const etapaLoPermite = etapaLlamadoConcurso?.idEtapaLlamadoConcurso > 4;

  // 👇 Solo lógica después de llamadas a hooks
  etc.withGrilla = isNotUser && etapaLoPermite;
  etc.withBases = isUser && etapaLoPermite;
  etc.withActions = isComite && esCoordinadorConcursal;
  etc.showBotonesActions = etapaLoPermite;

  return <PuestoTableContext.Provider value={etc}>{children}</PuestoTableContext.Provider>;
};

export const usePuestoTableConfig = () => useContext(PuestoTableContext);
